import { render, staticRenderFns } from "./PlayerCard.vue?vue&type=template&id=5c72af36&scoped=true"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"
import style0 from "./PlayerCard.vue?vue&type=style&index=0&id=5c72af36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72af36",
  null
  
)

export default component.exports